import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logoutUser } from "../redux/auth/actions";
import { Dropdown, Button, Modal } from "react-bootstrap";
import numberWithCommas from "../utils/numbersWithComma";
import Whatsapp from "../assets/images/icons/whatsapp.png";
import DepositIcon from "../assets/images/icons/deposit-icon.webp";
import Logo from "../assets/images/logo.webp";
import RupeeIcon from "../assets/images/icons/rupee-icon.svg";
import DollarIcon from "../assets/images/icons/dollar.svg";
import ArrowDown from "../assets/images/icons/arrow-down.webp";
import UserIcon from "../assets/images/icons/user-icon.webp";
import AviatorLogo from "../assets/images/icons/aviator-icon.webp";
import ArrowRight from "../assets/images/icons/arrow-right.webp";
import GiftIcon from "../assets/images/icons/gift-icon.webp";
import { AiOutlineClose } from "react-icons/ai";
import Bonuses from "../assets/images/icons/bonuses.webp";
import GamesSearchModal from "../views/components/GamesSearchModal";
import DepositModal from "../views/components/DepositModal";
import { getNotifications } from "../redux/app/actions";
import LanguageChange from "../views/components/LanguageChange";
import { useTranslation } from "react-i18next";
import CustomLanguageSelector from "../views/components/CustomLanguageSelector";
import ThemeSelector from "../views/components/ThemeSelector";

import ProfileIcon from "../assets/images/icons/user-dropdown/man.png";
import WithdrawIcon from "../assets/images/icons/user-dropdown/withdraw.png";
import BetHistoryIcon from "../assets/images/icons/user-dropdown/mybets.png";
import ReferralIcon from "../assets/images/icons/user-dropdown/referral.png";
import BonusIcon from "../assets/images/icons/user-dropdown/bonus.png";
import StatementIcon from "../assets/images/icons/user-dropdown/bethistoru.png";
import DepositHistoryIcon from "../assets/images/icons/user-dropdown/deposit.png";
import LogoutIcon from "../assets/images/icons/user-dropdown/logout.png";
import WithdrawHistoryIcon from "../assets/images/icons/user-dropdown/withdraw-history.png";

const HeaderAfterLogin = () => {
  const { wallet } = useSelector((state) => state.auth);

  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);

  const location = useLocation();
  const [activePage, setActivePage] = useState("");

  const { t } = useTranslation();
  const headerPages = [
    "home",
    "betby",
    "sports1",
    "casinogames",
    "livecasino",
    "aviator",
    "evolution",
    "ezugi",
    "supernowa",
    "vivo",
    "xpg",
    "worldcasino",
    "qtech",
    "atlas-lobby",
    "/",
    "spmsports",
  ];
  useEffect(() => {
    const matchedValue = headerPages.find((f) =>
      location?.pathname.includes(f)
    );
    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const [isSticky, setIsSticky] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;
      if (currentScrollTop > lastScrollTop && currentScrollTop > 0) {
        // Scrolling down
        setIsSticky(true);
      } else if (currentScrollTop <= 0) {
        // Remove sticky class when scrolled all the way up
        setIsSticky(false);
      }
      setLastScrollTop(currentScrollTop);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollTop]);

  const [isproviderActive, setIsproviderActive] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inlineStyle = isproviderActive ? { overflowX: "clip" } : {};
  const handleProvidersClick = () => {
    const isMobile = window.innerWidth < 992;

    if (isMobile) {
      setShowModal(true);
      document.body.classList.add("modal-providers-aftrlgn");
      document.documentElement.style.overflow = "hidden";
    } else {
      setIsproviderActive(!isproviderActive);
    }
  };

  const handleModalClose = () => {
    setShowModal(false);
    document.body.classList.remove("modal-providers");
    document.documentElement.style.overflow = "auto";
  };

  const menuItems = [
    { name: t("home"), path: "/", activeKey: "home" },
    {
      name: t("sports"),
      path: "/atlas-lobby",
      activeKey: "betby",
    },
    // { name: "Exchange 1", path: "/spmsports", activeKey: "spmsports" },

    { name: t("exchange"), path: "/sports/Inplay", activeKey: "sports1" },
    { name: t("casino"), path: "/casinogames", activeKey: "casinogames" },
    { name: t("live_games"), path: "/livecasino", activeKey: "livecasino" },
    {
      name: t("aviator"),
      path: "casino/spribe/aviator",
      activeKey: "aviator",
      isLogo: true,
      logo: AviatorLogo,
    },
  ];
  const providers = [
    { name: t("evolution"), path: "/casino/evolution", activeKey: "evolution" },
    { name: t("ezugi"), path: "/casino/ezugi", activeKey: "ezugi" },
    { name: t("supernowa"), path: "/casino/supernowa", activeKey: "supernowa" },
    { name: t("ivo"), path: "/casino/vivo", activeKey: "vivo" },
    // { name: "XPG", path: "/casino/xpg", activeKey: "xpg" },
    // {
    //   name: "Worldcasino",
    //   path: "/casino/worldcasino",
    //   activeKey: "worldcasino",
    // },
    { name: t("qtech"), path: "/casino/qtech", activeKey: "qtech" },
    { name: t("aura"), path: "/aura-games", activeKey: "aura" },
    { name: t("pragmaticplay"), path: "/pragmaticplay", activeKey: "pragmaticplay" },
    // { name: "ALT Gaming", path: "/gap", activeKey: "gap" },
  ];
  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };
  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header aftrlgn">
        <div className="top_head d-none d-lg-block">
          <div className="inner-box">
            <div className="left-section">
              {/* <a href="/promotions" className="vip-level">
              <span>Welcome Bonus</span>
              <span className="vip-icon"></span>
              <img src={ArrowRight} alt="right arrow" />
            </a> */}
              <div style={{ backgroundImage: "none" }} className="vip-level">
                <span></span>
              </div>
              <div className="vip-gift">
                <div className="vip-icon">
                  <a
                    className="whatsIcon"
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                  >
                    <div className="img-box">
                      <img src={Whatsapp} alt="whatsapp" />
                    </div>
                  </a>
                  <span className="vip-icon1"></span>
                  <span className="vip-icon2"></span>
                  <span className="dot1"></span>
                  <span className="dot2"></span>
                </div>

                {/* <a href="#" className="lucky-draw">
            <div className="text">
              <span>Lucky Drive</span>
              <small>Draw for a brand new Hyundai Creta</small>
            </div>
            <img src={WinningItem} alt="winning item" className="win-itme" />
          </a> */}
              </div>
            </div>

            <div className="right-section">
              <div>
                <ThemeSelector />
              </div>
              <div className="vip-gift">
                <a href="/promotions" className="promotion">
                  <div className="img-box">
                    <img src={GiftIcon} alt="promotions" />
                  </div>
                  <span>{t("promotion_and_bonuses")}</span>
                  <img src={Bonuses} alt="bonuses" className="bonus" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className={`bottom_head ${isSticky ? "sticky" : ""}`}>
          <div className="inner-box">
            <div className="logo">
              <a href="/">
                <img src={appDetails?.LOGO_URL} alt="Logo" height={60} />
                {/* <img src={Logo} alt="Logo" /> */}
              </a>
            </div>

            <div className="head-links">
              <ul style={inlineStyle}>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.path}
                      className={`
                      ${
                        location.pathname === item.path ||
                        activePage === item.activeKey
                          ? "active"
                          : ""
                      }
                      ${item.name === "Aviator" ? "game-logo" : ""}
                    `}
                    >
                      <span>
                        {item.isLogo ? (
                          <img src={item.logo} alt={item.name} />
                        ) : (
                          item.name
                        )}
                      </span>
                    </a>
                  </li>
                ))}
                <li className="providers">
                  <a href="javascript:void(0)" onClick={handleProvidersClick}>
                    <span>{t("games_by_provider")}</span>
                  </a>
                  <ul
                    className={`providers-games d-none d-md-flex ${
                      isproviderActive ? "active" : ""
                    }`}
                  >
                    {providers.map((provider) => (
                      <li key={provider.name}>
                        <a
                          href={provider.path}
                          className={
                            activePage === provider.activeKey ? "active" : ""
                          }
                        >
                          <span>{provider.name}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
                <li className="providers">
                  <LanguageChange />
                </li>

                <li className=" mx-3 d-none d-md-block">
                  <GamesSearchModal />
                </li>
                {/* <li className="providers">
                <a
                  href="/atlas-lobby"
                  className={activePage === "atlas-lobby" ? "active" : ""}
                >
                  <span>Sportsbook 2</span>
                </a>
              </li> */}
              </ul>

              <div className="d-lg-none">
                <GamesSearchModal />
              </div>
            </div>

            <div className="rightSec ms-lg-auto">
              <div className="bal-dpst">
                <div className="balance">
                  <span>
                    <span className="notranslate"></span>
                    <Dropdown align="end" className="balanceDropdown">
                      <Dropdown.Toggle variant="success" id="dropdown-balance">
                       Bal: <span>{numberWithCommas(wallet?.balance || 0)}</span>
                        <img src={ArrowDown} alt="balance" />
                      </Dropdown.Toggle>
                      {/* <Dropdown.Menu>
                        <div className="bal real">
                          <p>{t("main_wallet")}</p>
                          <div className="box"> */}
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            {/* <div className="amnt">
                              {numberWithCommas(wallet?.balance)}
                            </div>
                            <div className="dpst">
                              <a href="/gatewaylist">
                                <img src={DepositIcon} alt="deposit" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div className="bal cash">
                          <p>{t("cash")}</p>
                          <div className="box"> */}
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            {/* <div className="amnt">
                              {numberWithCommas(wallet?.cash)}
                            </div>
                          </div>
                        </div>
                        <div className="bal bonus">
                          <p>{t("bonus")}</p>
                          <div className="box"> */}
                            {/* <div className="img-box">
                              <img src={DollarIcon} alt="rupee" />
                            </div> */}
                            {/* <div className="amnt">
                              {numberWithCommas(wallet?.coins)}
                            </div>
                          </div>
                        </div>
                      </Dropdown.Menu> */}
                        <Dropdown.Menu>
                        <Dropdown.Item href="#">
                          <p>Balance</p>
                          <span>{numberWithCommas(wallet?.balance || 0)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                        >
                          <p>Cash</p>
                          <span>{numberWithCommas(wallet?.cash || 0)}</span>
                        </Dropdown.Item>

                        <Dropdown.Item>
                          <p>Bonus</p>
                          <span>{numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="/gatewaylist"
                          className="deposit btn-primary btn"
                        >
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown> 
                  </span>
                  {/* <strong>{wallet?.balance}</strong> */}
                </div>
                {/* <DepositModal /> */}
                <div className="dpst-btn">
                  <a href="/gatewaylist" className="btn">
                    {t("deposit")}
                  </a>
                </div>
              </div>

              <Dropdown align="end" className="userDropdown">
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={UserIcon} alt="user" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item href="/profile">
                    <img src={ProfileIcon} alt="ProfileIcon" /> {t("profile")}
                  </Dropdown.Item>

                  <Dropdown.Item href="/withdraw">
                    <img src={WithdrawIcon} alt="WithdrawIcon" />
                    {t("withdrawal")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/mybets">
                    <img src={BetHistoryIcon} alt="BetHistoryIcon" />
                    {t("bets_history")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/referral">
                    <img src={ReferralIcon} alt="ReferralIcon" />
                    {t("referral")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/bonus">
                    <img src={BonusIcon} alt="BonusIcon" />
                    {t("bonus")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/cashier">
                    <img src={StatementIcon} alt="StatementIcon" />
                    {t("statement")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/deposit/list">
                    <img src={DepositHistoryIcon} alt="DepositHistoryIcon" />
                    {t("deposit_history")}
                  </Dropdown.Item>
                  <Dropdown.Item href="/withdrawList">
                    <img src={WithdrawHistoryIcon} alt="WithdrawHistoryIcon" />
                    {t("withdraw_history")}
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#"
                    onClick={() => dispatch(logoutUser())}
                  >
                    <img src={LogoutIcon} alt="LogoutIcon" />
                    {t("log_out")}
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>

        <Modal
          className="providers-list"
          show={showModal}
          onHide={handleModalClose}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
        >
          <Modal.Body>
            <div className="providers-link">
              <ul>
                {providers.map((provider) => (
                  <li key={provider.name}>
                    <a
                      href={provider.path}
                      className={
                        activePage === provider.activeKey ? "active" : ""
                      }
                    >
                      <span>{provider.name}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};

export default HeaderAfterLogin;
